import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/sbci/fileuploadhistory'
import pathMap from 'src/paths/pathMap'

class FileuploadhistoryRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SBCI_FILE_UPLOAD_HISTORY_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SBCI_FILE_UPLOAD_HISTORY_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SBCI_FILE_UPLOAD_HISTORY_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SBCI_FILE_UPLOAD_HISTORY_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default FileuploadhistoryRoute
